import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import FloatPercentFormatInput from '../../components/float_percent_input_formatter';

const styles = theme => ({
    label: {
        fontSize: 15,
        fontWeight: '400',
        display: 'flex',
        alignItems: 'center',
        marginRight: 20,
    },
    buttonsBottom: {
        marginTop: 25,
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    radiobuttonLabel: {
        display: 'flex',
    },
    input: {
        marginRight: theme.spacing(3)
    },
    inputImporte: {
        textAlign: 'right',
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 12,
    },
});

class IncrPresupuestos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            origen: Math.round(this.props.oldPresupuesto * 100) / 100,
            newPresupuesto: Math.round(this.props.oldPresupuesto * 100) / 100,
            increment: 0,
            type: 'total'
        }
    }

    handleOptionChange = (event) => {
        this.setState({ ...this.state, type: event.target.value });
    }

    totalPresupuestoChange = (event) => {

        if (this.state.type === 'total') {

            const total = event.target.value;

            const percent = Math.round((total - this.state.origen) / this.state.origen * 100);

            this.setState({ ...this.state, newPresupuesto: total, increment: percent });
        }

    }

    percentPresupuestoChange = (event) => {

        if (this.state.type === 'percent') {
            const percent = event.target.value;

            const total = Math.round((1 + percent / 100) * this.state.origen);

            this.setState({ ...this.state, newPresupuesto: total, increment: percent });
        }

    }

    render() {

        const { classes } = this.props;

        return (
            <div>
                <form>

                    <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'Importe Anterior'}</Typography>
                    <TextField
                        disabled
                        id="oldPresupuesto"
                        value={this.props.oldPresupuesto}
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        variant="outlined"
                    />


                    <RadioGroup
                        style={{ display: 'flex', marginLeft: 16, marginBottom: 20 }}
                        aria-label="Copy Center"
                        name="copyCenter"
                        value={this.state.type}
                        onChange={(event) => this.handleOptionChange(event)}
                    >
                        <FormControlLabel value="total" className={classes.label} control={<Radio />} label={
                            <div className={classes.radiobuttonLabel}>
                                <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'Nuevo Importe (€)'}</Typography>
                                <TextField
                                    disabled={this.state.type === 'percent'}
                                    id="total"
                                    value={this.state.newPresupuesto}
                                    onChange={this.totalPresupuestoChange}
                                    className={classes.input}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                    variant="outlined"
                                />
                            </div>
                        } />
                        <FormControlLabel value="percent" control={<Radio />} label={
                            <div className={classes.radiobuttonLabel}>
                                <Typography variant="subtitle2" style={{ margin: '10px 8px' }}>{'Incremento (%)'}</Typography>
                                <TextField
                                    disabled={this.state.type === 'total'}
                                    id="percent"
                                    value={this.state.increment}
                                    onChange={this.percentPresupuestoChange}
                                    className={classes.input}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                                    variant="outlined"
                                />
                            </div>
                        } />
                    </RadioGroup>

                    <div>
                        <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                        <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {

                            this.props.okHandler(this.state.newPresupuesto);
                            this.props.hideDialog();

                        }}>Aplicar</Button>
                    </div>


                </form>

            </div>
        );
    };

};

IncrPresupuestos.propTypes = {

    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    oldPresupuesto: PropTypes.string.isRequired,
    okHandler: PropTypes.func.isRequired,

};



export default withStyles(styles, { withTheme: true })(IncrPresupuestos);